import { requestAPI } from '../../helpers/request';
import { getAuthHeader } from '../../helpers/auth';

const basePath = '/device';

const requestDevices = (params) => {
  const path = `${basePath}`;
  const authHeader = getAuthHeader(); // { Authorization: Bearer xyz }

  return requestAPI(
    path,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...authHeader,
      },
    },
    params,
  )
    .then((response) => Promise.resolve(response))
    .catch((error) => {
      throw error;
    });
};

const requestUpdateDevice = (_id, body) => {
  const path = `${basePath}/${_id}`;
  const authHeader = getAuthHeader(); // { Authorization: Bearer xyz }

  return requestAPI(path, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader,
    },
    body: JSON.stringify(body),
  })
    .then((response) => Promise.resolve(response))
    .catch((error) => {
      throw error;
    });
};

export default {
  requestDevices,
  requestUpdateDevice,
};
